import React from 'react';
import { Modal, ModalBody, ModalFooter, ModalHeader } from 'reactstrap';
import {
  checkIfHasAllowedCharacters,
  firstCharIsNotSpecialChar
} from '../../util/stringUtils';
import style from './index.scss';

const DEFAULT_STATE = {
  groupName: '',
  error: null
};

/**
 * AddNewGroupModal Component
 */
class AddNewGroupModal extends React.Component {
  state = {
    ...DEFAULT_STATE
  };

  checkGroupNameExists = (groupName) => {
    const { groups } = this.props;
    const existingGroupsWithSameName = groups.filter(
      (group) =>
        String(group.groupName).toUpperCase() ===
        String(groupName).toUpperCase()
    );

    return existingGroupsWithSameName.length > 0;
  };

  onConfirmButtonClick = (groupName) => {
    const { onConfirmClick } = this.props;

    if (groupName && groupName.length >= 3 && groupName.length <= 20) {
      if (checkIfHasAllowedCharacters(groupName)) {
        if (firstCharIsNotSpecialChar(groupName)) {
          if (!this.checkGroupNameExists(groupName)) {
            onConfirmClick({
              groupName,
              items: [],
              isVisible: true
            });

            this.setState({
              ...DEFAULT_STATE
            });
          } else {
            this.setState({
              error: 'Group name already exists.'
            });
          }
        } else {
          this.setState({
            error: 'Column name should not start with a special character.'
          });
        }
      } else {
        this.setState({
          error: 'Following special characters are allowed :./-&$#@(){}\\'
        });
      }
    } else {
      this.setState({
        error: 'Column name should have 3-20 characters.'
      });
    }
  };

  onCancelButtonClick = () => {
    const { onModalToggle } = this.props;

    if (onModalToggle) {
      onModalToggle();
    }

    this.setState({
      ...DEFAULT_STATE
    });
  };

  onGroupNameChange = (e) => {
    const groupName = e.target.value;
    this.setState({
      groupName
    });
  };

  onModalClosed = () => {
    this.setState({
      ...DEFAULT_STATE
    });
  };

  /**
   * Render function
   * @returns {Modal}
   */
  render() {
    const { isShown, onModalToggle } = this.props;

    const { groupName, error } = this.state;
    return (
      <div>
        <Modal
          size="lg"
          isOpen={isShown}
          toggle={onModalToggle}
          onClosed={this.onModalClosed}>
          <ModalHeader>
            <p>Add new column</p>
          </ModalHeader>
          <ModalBody>
            <div className={style.modalStyles}>
              <div className="row">
                <div className="offset-md-3 col-md-6">
                  <p className={style.modalLabel}>
                    Column name &nbsp;
                    <input
                      className={style.modalTextbox}
                      onChange={(e) => this.onGroupNameChange(e)}
                      value={groupName}
                      type="text"
                      placeholder="Minimum 3 characters"
                    />
                  </p>
                  <p style={{ color: 'red' }}>{error ? error : null}</p>
                </div>
              </div>
            </div>
          </ModalBody>
          <ModalFooter>
            <button
              className={style.secondaryButton}
              onClick={this.onCancelButtonClick}>
              Cancel
            </button>
            <button
              className={style.primaryButton}
              onClick={() => this.onConfirmButtonClick(groupName)}>
              Confirm
            </button>
          </ModalFooter>
        </Modal>
      </div>
    );
  }
}

/**
 * defaultProps
 * @type {{
 * isShown: boolean,
 * onConfirmClick: method,
 * onModalToggle: method,
 * }}
 */
AddNewGroupModal.defaultProps = {
  isShown: false,
  onConfirmClick: () => {},
  onModalToggle: () => {}
};

/**
 * AddNewGroupModal
 */
export default AddNewGroupModal;
